// Mock data for DiaWise MVP

export const mockUser = {
  user_id: 'user_001',
  name: 'Sarah Johnson',
  age: 42,
  diabetes_type: 'Type 2',
  email: 'sarah.johnson@example.com',
  target_glucose_min: 80,
  target_glucose_max: 130
};

export const mockGlucoseLogs = [
  {
    log_id: 'gl_001',
    user_id: 'user_001',
    glucose_value: 105,
    time: new Date('2025-01-15T08:30:00'),
    meal_relation: 'Before Breakfast'
  },
  {
    log_id: 'gl_002',
    user_id: 'user_001',
    glucose_value: 142,
    time: new Date('2025-01-15T10:30:00'),
    meal_relation: 'After Breakfast'
  },
  {
    log_id: 'gl_003',
    user_id: 'user_001',
    glucose_value: 98,
    time: new Date('2025-01-15T12:00:00'),
    meal_relation: 'Before Lunch'
  },
  {
    log_id: 'gl_004',
    user_id: 'user_001',
    glucose_value: 156,
    time: new Date('2025-01-15T14:00:00'),
    meal_relation: 'After Lunch'
  },
  {
    log_id: 'gl_005',
    user_id: 'user_001',
    glucose_value: 92,
    time: new Date('2025-01-15T18:00:00'),
    meal_relation: 'Before Dinner'
  },
  {
    log_id: 'gl_006',
    user_id: 'user_001',
    glucose_value: 118,
    time: new Date('2025-01-14T08:30:00'),
    meal_relation: 'Before Breakfast'
  },
  {
    log_id: 'gl_007',
    user_id: 'user_001',
    glucose_value: 135,
    time: new Date('2025-01-14T10:30:00'),
    meal_relation: 'After Breakfast'
  },
  {
    log_id: 'gl_008',
    user_id: 'user_001',
    glucose_value: 102,
    time: new Date('2025-01-13T08:30:00'),
    meal_relation: 'Before Breakfast'
  }
];

export const mockMeals = [
  {
    meal_id: 'meal_001',
    user_id: 'user_001',
    meal_name: 'Oatmeal with Berries',
    carbs: 45,
    sugar: 12,
    time: new Date('2025-01-15T09:00:00'),
    calories: 320
  },
  {
    meal_id: 'meal_002',
    user_id: 'user_001',
    meal_name: 'Grilled Chicken Salad',
    carbs: 28,
    sugar: 8,
    time: new Date('2025-01-15T13:00:00'),
    calories: 410
  },
  {
    meal_id: 'meal_003',
    user_id: 'user_001',
    meal_name: 'Salmon with Vegetables',
    carbs: 35,
    sugar: 6,
    time: new Date('2025-01-15T19:00:00'),
    calories: 520
  },
  {
    meal_id: 'meal_004',
    user_id: 'user_001',
    meal_name: 'Greek Yogurt with Almonds',
    carbs: 22,
    sugar: 15,
    time: new Date('2025-01-15T15:30:00'),
    calories: 210
  },
  {
    meal_id: 'meal_005',
    user_id: 'user_001',
    meal_name: 'Whole Wheat Toast with Avocado',
    carbs: 38,
    sugar: 4,
    time: new Date('2025-01-14T09:00:00'),
    calories: 280
  }
];

export const mockMedications = [
  {
    reminder_id: 'med_001',
    user_id: 'user_001',
    medication_name: 'Metformin',
    dosage: '500mg',
    schedule_time: '08:00',
    frequency: 'Twice Daily',
    taken_today: true,
    type: 'medication'
  },
  {
    reminder_id: 'med_002',
    user_id: 'user_001',
    medication_name: 'Metformin',
    dosage: '500mg',
    schedule_time: '20:00',
    frequency: 'Twice Daily',
    taken_today: false,
    type: 'medication'
  },
  {
    reminder_id: 'med_003',
    user_id: 'user_001',
    medication_name: 'Vitamin D',
    dosage: '1000 IU',
    schedule_time: '09:00',
    frequency: 'Daily',
    taken_today: true,
    type: 'medication'
  },
  {
    reminder_id: 'insulin_001',
    user_id: 'user_001',
    medication_name: 'Rapid-Acting Insulin',
    dosage: '10 units',
    schedule_time: '07:00',
    frequency: 'Before Breakfast',
    taken_today: true,
    type: 'insulin',
    insulin_type: 'rapid'
  },
  {
    reminder_id: 'insulin_002',
    user_id: 'user_001',
    medication_name: 'Rapid-Acting Insulin',
    dosage: '12 units',
    schedule_time: '12:00',
    frequency: 'Before Lunch',
    taken_today: true,
    type: 'insulin',
    insulin_type: 'rapid'
  },
  {
    reminder_id: 'insulin_003',
    user_id: 'user_001',
    medication_name: 'Rapid-Acting Insulin',
    dosage: '14 units',
    schedule_time: '18:00',
    frequency: 'Before Dinner',
    taken_today: false,
    type: 'insulin',
    insulin_type: 'rapid'
  },
  {
    reminder_id: 'insulin_004',
    user_id: 'user_001',
    medication_name: 'Long-Acting Insulin',
    dosage: '20 units',
    schedule_time: '22:00',
    frequency: 'Bedtime',
    taken_today: false,
    type: 'insulin',
    insulin_type: 'long'
  }
];

export const mockInsights = [
  {
    insight_id: 'insight_001',
    user_id: 'user_001',
    generated_text: 'Your glucose levels have been stable over the past week, averaging 115 mg/dL. Great job maintaining consistency!',
    date: new Date('2025-01-15'),
    category: 'Progress',
    priority: 'high'
  },
  {
    insight_id: 'insight_002',
    user_id: 'user_001',
    generated_text: 'Consider reducing carbohydrate intake at lunch. Your post-lunch readings tend to spike above 150 mg/dL.',
    date: new Date('2025-01-15'),
    category: 'Nutrition',
    priority: 'medium'
  },
  {
    insight_id: 'insight_003',
    user_id: 'user_001',
    generated_text: 'Your medication adherence is excellent at 95% this week. Keep up the great work!',
    date: new Date('2025-01-14'),
    category: 'Medication',
    priority: 'low'
  },
  {
    insight_id: 'insight_004',
    user_id: 'user_001',
    generated_text: 'Morning glucose readings are consistently within your target range. Your breakfast choices are working well.',
    date: new Date('2025-01-13'),
    category: 'Progress',
    priority: 'high'
  }
];

export const mockRecipes = [
  {
    recipe_id: 'recipe_001',
    name: 'Quinoa Buddha Bowl',
    description: 'A nutritious bowl packed with protein and fiber',
    carbs: 42,
    sugar: 6,
    calories: 380,
    protein: 18,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Quinoa', 'Chickpeas', 'Kale', 'Cherry Tomatoes', 'Tahini Dressing'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_002',
    name: 'Grilled Lemon Herb Chicken',
    description: 'Tender chicken breast with fresh herbs',
    carbs: 8,
    sugar: 2,
    calories: 290,
    protein: 42,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken Breast', 'Lemon', 'Rosemary', 'Thyme', 'Olive Oil'],
    image: 'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_003',
    name: 'Mediterranean Salad',
    description: 'Fresh and crisp with a tangy vinaigrette',
    carbs: 18,
    sugar: 8,
    calories: 220,
    protein: 12,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Mixed Greens', 'Cucumber', 'Feta Cheese', 'Olives', 'Red Onion'],
    image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_004',
    name: 'Baked Salmon with Asparagus',
    description: 'Omega-3 rich salmon with roasted vegetables',
    carbs: 12,
    sugar: 4,
    calories: 420,
    protein: 38,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Salmon Fillet', 'Asparagus', 'Garlic', 'Lemon', 'Dill'],
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_005',
    name: 'Berry Smoothie Bowl',
    description: 'Antioxidant-rich breakfast bowl',
    carbs: 38,
    sugar: 22,
    calories: 280,
    protein: 10,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Mixed Berries', 'Greek Yogurt', 'Chia Seeds', 'Granola', 'Honey'],
    image: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_006',
    name: 'Vegetable Stir-Fry',
    description: 'Colorful mix of crisp vegetables',
    carbs: 32,
    sugar: 10,
    calories: 240,
    protein: 14,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Broccoli', 'Bell Peppers', 'Carrots', 'Tofu', 'Soy Sauce'],
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_007',
    name: 'Avocado Toast with Poached Egg',
    description: 'Classic breakfast with healthy fats and protein',
    carbs: 28,
    sugar: 3,
    calories: 340,
    protein: 16,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Wheat Bread', 'Avocado', 'Eggs', 'Cherry Tomatoes', 'Pepper'],
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_008',
    name: 'Turkey Lettuce Wraps',
    description: 'Low-carb lunch with lean protein',
    carbs: 12,
    sugar: 4,
    calories: 260,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Ground Turkey', 'Lettuce', 'Bell Peppers', 'Water Chestnuts', 'Ginger'],
    image: 'https://images.unsplash.com/photo-1559847844-5315695dadae?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_009',
    name: 'Spinach and Mushroom Omelette',
    description: 'Protein-packed breakfast with vegetables',
    carbs: 8,
    sugar: 2,
    calories: 250,
    protein: 22,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Eggs', 'Spinach', 'Mushrooms', 'Onion', 'Cheese'],
    image: 'https://images.unsplash.com/photo-1525351159099-12e5a0284c5b?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_010',
    name: 'Zucchini Noodles with Pesto',
    description: 'Low-carb pasta alternative with fresh basil',
    carbs: 18,
    sugar: 6,
    calories: 280,
    protein: 12,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Zucchini', 'Basil', 'Pine Nuts', 'Parmesan', 'Garlic'],
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_011',
    name: 'Greek Yogurt Parfait',
    description: 'Layered breakfast with protein and fruit',
    carbs: 35,
    sugar: 18,
    calories: 290,
    protein: 15,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Greek Yogurt', 'Berries', 'Granola', 'Honey', 'Almonds'],
    image: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_012',
    name: 'Chicken Caesar Salad',
    description: 'Classic salad with grilled chicken',
    carbs: 22,
    sugar: 4,
    calories: 380,
    protein: 36,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken Breast', 'Romaine Lettuce', 'Parmesan', 'Caesar Dressing', 'Croutons'],
    image: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_013',
    name: 'Baked Cod with Vegetables',
    description: 'Light fish dinner with roasted veggies',
    carbs: 20,
    sugar: 6,
    calories: 310,
    protein: 34,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Cod Fillet', 'Broccoli', 'Carrots', 'Lemon', 'Herbs'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_014',
    name: 'Almond Butter Banana Toast',
    description: 'Quick energizing breakfast',
    carbs: 32,
    sugar: 14,
    calories: 320,
    protein: 12,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Wheat Bread', 'Almond Butter', 'Banana', 'Cinnamon', 'Chia Seeds'],
    image: 'https://images.unsplash.com/photo-1525351326368-efbb5cb6814d?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_015',
    name: 'Shrimp Cauliflower Fried Rice',
    description: 'Low-carb version of classic fried rice',
    carbs: 24,
    sugar: 5,
    calories: 290,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Shrimp', 'Cauliflower', 'Eggs', 'Peas', 'Soy Sauce'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_016',
    name: 'Cottage Cheese Bowl',
    description: 'High-protein breakfast with fresh fruit',
    carbs: 28,
    sugar: 16,
    calories: 260,
    protein: 24,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Cottage Cheese', 'Berries', 'Walnuts', 'Honey', 'Flax Seeds'],
    image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_017',
    name: 'Lentil Vegetable Soup',
    description: 'Hearty fiber-rich soup',
    carbs: 38,
    sugar: 8,
    calories: 280,
    protein: 16,
    prep_time: '45 mins',
    difficulty: 'Medium',
    ingredients: ['Lentils', 'Carrots', 'Celery', 'Tomatoes', 'Spinach'],
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_018',
    name: 'Grilled Tuna Steak',
    description: 'Seared tuna with sesame crust',
    carbs: 6,
    sugar: 2,
    calories: 340,
    protein: 42,
    prep_time: '20 mins',
    difficulty: 'Medium',
    ingredients: ['Tuna Steak', 'Sesame Seeds', 'Soy Sauce', 'Ginger', 'Green Beans'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_019',
    name: 'Chia Seed Pudding',
    description: 'Overnight breakfast rich in omega-3',
    carbs: 30,
    sugar: 14,
    calories: 240,
    protein: 8,
    prep_time: '5 mins + overnight',
    difficulty: 'Easy',
    ingredients: ['Chia Seeds', 'Almond Milk', 'Vanilla', 'Berries', 'Maple Syrup'],
    image: 'https://images.unsplash.com/photo-1623428454614-abaf00244e52?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_020',
    name: 'Caprese Stuffed Chicken',
    description: 'Chicken breast with mozzarella and tomato',
    carbs: 10,
    sugar: 4,
    calories: 360,
    protein: 44,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken Breast', 'Mozzarella', 'Tomatoes', 'Basil', 'Balsamic'],
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_021',
    name: 'Veggie Egg Muffins',
    description: 'Portable protein-packed breakfast',
    carbs: 12,
    sugar: 3,
    calories: 180,
    protein: 14,
    prep_time: '30 mins',
    difficulty: 'Easy',
    ingredients: ['Eggs', 'Bell Peppers', 'Spinach', 'Cheese', 'Onion'],
    image: 'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_022',
    name: 'Asian Sesame Chicken Salad',
    description: 'Crunchy salad with Asian dressing',
    carbs: 26,
    sugar: 8,
    calories: 340,
    protein: 32,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Cabbage', 'Carrots', 'Edamame', 'Sesame Dressing'],
    image: 'https://images.unsplash.com/photo-1551248429-40975aa4de74?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_023',
    name: 'Beef and Broccoli',
    description: 'Classic Chinese-style stir-fry',
    carbs: 22,
    sugar: 6,
    calories: 380,
    protein: 38,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Beef', 'Broccoli', 'Garlic', 'Ginger', 'Soy Sauce'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_024',
    name: 'Protein Pancakes',
    description: 'Fluffy pancakes with added protein',
    carbs: 36,
    sugar: 10,
    calories: 320,
    protein: 20,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Protein Powder', 'Oats', 'Eggs', 'Banana', 'Blueberries'],
    image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_025',
    name: 'Nicoise Salad',
    description: 'French salad with tuna and vegetables',
    carbs: 24,
    sugar: 6,
    calories: 360,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Tuna', 'Green Beans', 'Potatoes', 'Eggs', 'Olives'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_026',
    name: 'Turkey Meatballs with Marinara',
    description: 'Lean meatballs in tomato sauce',
    carbs: 28,
    sugar: 8,
    calories: 340,
    protein: 36,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Ground Turkey', 'Tomato Sauce', 'Herbs', 'Garlic', 'Parmesan'],
    image: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_027',
    name: 'Green Smoothie',
    description: 'Nutrient-dense breakfast drink',
    carbs: 32,
    sugar: 18,
    calories: 220,
    protein: 8,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Spinach', 'Banana', 'Mango', 'Almond Milk', 'Protein Powder'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_028',
    name: 'Thai Peanut Chicken Bowl',
    description: 'Asian-inspired bowl with peanut sauce',
    carbs: 38,
    sugar: 10,
    calories: 420,
    protein: 34,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Brown Rice', 'Peanut Sauce', 'Vegetables', 'Cilantro'],
    image: 'https://images.unsplash.com/photo-1624300629298-e9de39c13be5?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_029',
    name: 'Herb-Crusted Pork Tenderloin',
    description: 'Juicy pork with herb coating',
    carbs: 14,
    sugar: 4,
    calories: 350,
    protein: 40,
    prep_time: '45 mins',
    difficulty: 'Medium',
    ingredients: ['Pork Tenderloin', 'Herbs', 'Garlic', 'Brussels Sprouts', 'Sweet Potato'],
    image: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_030',
    name: 'Shakshuka',
    description: 'Middle Eastern eggs in tomato sauce',
    carbs: 22,
    sugar: 10,
    calories: 280,
    protein: 18,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Eggs', 'Tomatoes', 'Bell Peppers', 'Onion', 'Spices'],
    image: 'https://images.unsplash.com/photo-1587496679742-bad502958fbf?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_031',
    name: 'Overnight Oats with Berries',
    description: 'No-cook breakfast prepared the night before',
    carbs: 42,
    sugar: 14,
    calories: 310,
    protein: 12,
    prep_time: '5 mins + overnight',
    difficulty: 'Easy',
    ingredients: ['Rolled Oats', 'Almond Milk', 'Mixed Berries', 'Honey', 'Walnuts'],
    image: 'https://images.unsplash.com/photo-1517673132405-a56a62b18caf?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_032',
    name: 'Whole Grain Waffles',
    description: 'Crispy waffles with whole wheat flour',
    carbs: 48,
    sugar: 12,
    calories: 350,
    protein: 14,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Wheat Flour', 'Eggs', 'Milk', 'Banana', 'Blueberries'],
    image: 'https://images.unsplash.com/photo-1568051243851-f9b136146e97?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_033',
    name: 'Smoked Salmon Bagel',
    description: 'Classic bagel with cream cheese and salmon',
    carbs: 38,
    sugar: 6,
    calories: 380,
    protein: 22,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Wheat Bagel', 'Cream Cheese', 'Smoked Salmon', 'Capers', 'Red Onion'],
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_034',
    name: 'Breakfast Burrito',
    description: 'Scrambled eggs wrapped in whole wheat tortilla',
    carbs: 35,
    sugar: 4,
    calories: 390,
    protein: 24,
    prep_time: '20 mins',
    difficulty: 'Medium',
    ingredients: ['Whole Wheat Tortilla', 'Eggs', 'Black Beans', 'Cheese', 'Salsa'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_035',
    name: 'Acai Bowl',
    description: 'Brazilian superfood bowl',
    carbs: 45,
    sugar: 24,
    calories: 320,
    protein: 8,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Acai Puree', 'Banana', 'Granola', 'Coconut', 'Berries'],
    image: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_036',
    name: 'Frittata with Vegetables',
    description: 'Italian-style baked egg dish',
    carbs: 14,
    sugar: 6,
    calories: 280,
    protein: 20,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Eggs', 'Zucchini', 'Tomatoes', 'Feta', 'Herbs'],
    image: 'https://images.unsplash.com/photo-1612240498936-65f5494034e6?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_037',
    name: 'Peanut Butter Oatmeal',
    description: 'Warm oats with creamy peanut butter',
    carbs: 46,
    sugar: 12,
    calories: 380,
    protein: 16,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Oats', 'Peanut Butter', 'Banana', 'Cinnamon', 'Milk'],
    image: 'https://images.unsplash.com/photo-1517673132405-a56a62b18caf?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_038',
    name: 'Breakfast Quinoa Bowl',
    description: 'Protein-rich quinoa with fruit',
    carbs: 44,
    sugar: 16,
    calories: 330,
    protein: 12,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Quinoa', 'Almond Milk', 'Berries', 'Almonds', 'Maple Syrup'],
    image: 'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_039',
    name: 'English Muffin Breakfast Sandwich',
    description: 'Egg and cheese on whole grain muffin',
    carbs: 32,
    sugar: 4,
    calories: 340,
    protein: 22,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['English Muffin', 'Eggs', 'Canadian Bacon', 'Cheese', 'Spinach'],
    image: 'https://images.unsplash.com/photo-1619643753217-35d0833f2e26?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_040',
    name: 'Banana Nut Muffins',
    description: 'Homemade whole wheat muffins',
    carbs: 38,
    sugar: 18,
    calories: 280,
    protein: 8,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Whole Wheat Flour', 'Banana', 'Walnuts', 'Honey', 'Eggs'],
    image: 'https://images.unsplash.com/photo-1607958996333-41aef7caefaa?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_041',
    name: 'Scrambled Tofu',
    description: 'Plant-based protein scramble',
    carbs: 18,
    sugar: 4,
    calories: 240,
    protein: 20,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Tofu', 'Turmeric', 'Vegetables', 'Nutritional Yeast', 'Spinach'],
    image: 'https://images.unsplash.com/photo-1607532941433-304659e8198a?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_042',
    name: 'Huevos Rancheros',
    description: 'Mexican-style eggs with salsa',
    carbs: 36,
    sugar: 6,
    calories: 360,
    protein: 20,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Eggs', 'Corn Tortillas', 'Black Beans', 'Salsa', 'Avocado'],
    image: 'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_043',
    name: 'Blueberry Protein Smoothie',
    description: 'Thick and creamy breakfast smoothie',
    carbs: 34,
    sugar: 20,
    calories: 290,
    protein: 24,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Blueberries', 'Protein Powder', 'Banana', 'Almond Milk', 'Spinach'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_044',
    name: 'Cinnamon Apple Oatmeal',
    description: 'Warm spiced oatmeal with apples',
    carbs: 48,
    sugar: 16,
    calories: 310,
    protein: 10,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Oats', 'Apple', 'Cinnamon', 'Walnuts', 'Maple Syrup'],
    image: 'https://images.unsplash.com/photo-1517673132405-a56a62b18caf?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_045',
    name: 'Breakfast Couscous',
    description: 'Sweet couscous with dried fruit',
    carbs: 46,
    sugar: 18,
    calories: 300,
    protein: 10,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Couscous', 'Dried Fruit', 'Almonds', 'Cinnamon', 'Honey'],
    image: 'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_046',
    name: 'Egg White Omelette',
    description: 'Light omelette with vegetables',
    carbs: 10,
    sugar: 4,
    calories: 180,
    protein: 24,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Egg Whites', 'Mushrooms', 'Peppers', 'Onion', 'Low-fat Cheese'],
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_047',
    name: 'Buckwheat Pancakes',
    description: 'Nutty-flavored gluten-free pancakes',
    carbs: 42,
    sugar: 10,
    calories: 320,
    protein: 12,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Buckwheat Flour', 'Eggs', 'Milk', 'Blueberries', 'Yogurt'],
    image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_048',
    name: 'Mango Coconut Smoothie Bowl',
    description: 'Tropical breakfast bowl',
    carbs: 48,
    sugar: 28,
    calories: 340,
    protein: 8,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Mango', 'Coconut Milk', 'Banana', 'Chia Seeds', 'Coconut Flakes'],
    image: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_049',
    name: 'Breakfast Tacos',
    description: 'Soft tacos with scrambled eggs',
    carbs: 32,
    sugar: 4,
    calories: 350,
    protein: 20,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Corn Tortillas', 'Eggs', 'Black Beans', 'Cheese', 'Pico de Gallo'],
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_050',
    name: 'Ricotta Toast with Honey',
    description: 'Creamy ricotta on toasted bread',
    carbs: 34,
    sugar: 12,
    calories: 300,
    protein: 16,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Grain Bread', 'Ricotta', 'Honey', 'Berries', 'Mint'],
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_051',
    name: 'Breakfast Barley',
    description: 'Hearty grain bowl with fruit',
    carbs: 50,
    sugar: 14,
    calories: 320,
    protein: 10,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Barley', 'Milk', 'Dried Fruit', 'Pecans', 'Brown Sugar'],
    image: 'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_052',
    name: 'Turkey Sausage Breakfast Bowl',
    description: 'Lean protein breakfast bowl',
    carbs: 28,
    sugar: 4,
    calories: 360,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Turkey Sausage', 'Eggs', 'Sweet Potato', 'Spinach', 'Onion'],
    image: 'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_053',
    name: 'Chocolate Protein Shake',
    description: 'Rich chocolate breakfast shake',
    carbs: 28,
    sugar: 16,
    calories: 280,
    protein: 26,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Chocolate Protein Powder', 'Banana', 'Almond Milk', 'Peanut Butter', 'Ice'],
    image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_054',
    name: 'Baked Eggs in Avocado',
    description: 'Eggs baked in avocado halves',
    carbs: 16,
    sugar: 2,
    calories: 280,
    protein: 14,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Avocado', 'Eggs', 'Bacon Bits', 'Cheese', 'Chives'],
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_055',
    name: 'Granola Yogurt Crunch',
    description: 'Layered yogurt with homemade granola',
    carbs: 44,
    sugar: 20,
    calories: 340,
    protein: 14,
    prep_time: '10 mins',
    difficulty: 'Easy',
    ingredients: ['Greek Yogurt', 'Homemade Granola', 'Berries', 'Honey', 'Almonds'],
    image: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_056',
    name: 'French Toast Sticks',
    description: 'Whole wheat French toast strips',
    carbs: 46,
    sugar: 14,
    calories: 340,
    protein: 12,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Whole Wheat Bread', 'Eggs', 'Cinnamon', 'Vanilla', 'Maple Syrup'],
    image: 'https://images.unsplash.com/photo-1484723091739-30a097e8f929?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_057',
    name: 'Mediterranean Breakfast Plate',
    description: 'Assorted Mediterranean breakfast items',
    carbs: 32,
    sugar: 8,
    calories: 380,
    protein: 18,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Pita Bread', 'Hummus', 'Olives', 'Feta', 'Tomatoes', 'Cucumber'],
    image: 'https://images.unsplash.com/photo-1505576391880-b3f9d713dc4f?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_058',
    name: 'Breakfast Polenta',
    description: 'Creamy cornmeal porridge',
    carbs: 42,
    sugar: 12,
    calories: 300,
    protein: 10,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Polenta', 'Milk', 'Berries', 'Honey', 'Pistachios'],
    image: 'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_059',
    name: 'Breakfast Sushi Roll',
    description: 'Creative rolled breakfast',
    carbs: 38,
    sugar: 10,
    calories: 310,
    protein: 12,
    prep_time: '20 mins',
    difficulty: 'Medium',
    ingredients: ['Whole Wheat Tortilla', 'Peanut Butter', 'Banana', 'Granola', 'Honey'],
    image: 'https://images.unsplash.com/photo-1525351484163-7529414344d8?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_060',
    name: 'Mushroom Spinach Scramble',
    description: 'Savory scrambled eggs with vegetables',
    carbs: 12,
    sugar: 4,
    calories: 260,
    protein: 22,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Eggs', 'Mushrooms', 'Spinach', 'Garlic', 'Goat Cheese'],
    image: 'https://images.unsplash.com/photo-1608039829572-78524f79c4c7?w=400',
    meal_type: 'Breakfast'
  },
  {
    recipe_id: 'recipe_061',
    name: 'Classic Green Detox Smoothie',
    description: 'Refreshing green smoothie for detox',
    carbs: 28,
    sugar: 16,
    calories: 180,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Spinach', 'Cucumber', 'Green Apple', 'Lemon', 'Ginger'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_062',
    name: 'Tropical Mango Pineapple Smoothie',
    description: 'Sunny tropical fruit blend',
    carbs: 35,
    sugar: 26,
    calories: 220,
    protein: 4,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Mango', 'Pineapple', 'Coconut Water', 'Banana', 'Lime'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_063',
    name: 'Berry Blast Protein Smoothie',
    description: 'Antioxidant-rich berry protein shake',
    carbs: 32,
    sugar: 18,
    calories: 280,
    protein: 24,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Mixed Berries', 'Protein Powder', 'Greek Yogurt', 'Almond Milk', 'Honey'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_064',
    name: 'Peanut Butter Banana Smoothie',
    description: 'Creamy and filling protein smoothie',
    carbs: 38,
    sugar: 20,
    calories: 340,
    protein: 16,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Banana', 'Peanut Butter', 'Oats', 'Almond Milk', 'Cinnamon'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_065',
    name: 'Avocado Kale Power Smoothie',
    description: 'Nutrient-dense green power smoothie',
    carbs: 26,
    sugar: 12,
    calories: 260,
    protein: 8,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Avocado', 'Kale', 'Banana', 'Almond Milk', 'Chia Seeds'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_066',
    name: 'Chocolate Cherry Smoothie',
    description: 'Indulgent yet healthy chocolate treat',
    carbs: 34,
    sugar: 22,
    calories: 280,
    protein: 12,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Cherries', 'Cocoa Powder', 'Greek Yogurt', 'Almond Milk', 'Vanilla'],
    image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_067',
    name: 'Strawberry Spinach Smoothie',
    description: 'Sweet and green nutrient boost',
    carbs: 30,
    sugar: 18,
    calories: 190,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Strawberries', 'Spinach', 'Banana', 'Orange Juice', 'Flax Seeds'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_068',
    name: 'Peach Ginger Turmeric Smoothie',
    description: 'Anti-inflammatory golden smoothie',
    carbs: 32,
    sugar: 24,
    calories: 210,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Peaches', 'Ginger', 'Turmeric', 'Coconut Milk', 'Honey'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_069',
    name: 'Blueberry Almond Butter Smoothie',
    description: 'Rich and creamy nut butter smoothie',
    carbs: 36,
    sugar: 20,
    calories: 310,
    protein: 12,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Blueberries', 'Almond Butter', 'Banana', 'Almond Milk', 'Dates'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_070',
    name: 'Carrot Cake Smoothie',
    description: 'Dessert-inspired healthy smoothie',
    carbs: 38,
    sugar: 22,
    calories: 270,
    protein: 10,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Carrots', 'Banana', 'Cinnamon', 'Walnuts', 'Greek Yogurt'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_071',
    name: 'Matcha Green Tea Smoothie',
    description: 'Energizing matcha superfood smoothie',
    carbs: 28,
    sugar: 16,
    calories: 220,
    protein: 8,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Matcha Powder', 'Banana', 'Spinach', 'Almond Milk', 'Honey'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_072',
    name: 'Raspberry Coconut Smoothie',
    description: 'Tropical pink paradise smoothie',
    carbs: 30,
    sugar: 18,
    calories: 240,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Raspberries', 'Coconut Milk', 'Banana', 'Coconut Flakes', 'Vanilla'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_073',
    name: 'Orange Creamsicle Smoothie',
    description: 'Nostalgic citrus cream smoothie',
    carbs: 34,
    sugar: 24,
    calories: 250,
    protein: 10,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Orange', 'Greek Yogurt', 'Banana', 'Vanilla', 'Honey'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_074',
    name: 'Beet Berry Power Smoothie',
    description: 'Vibrant red superfood blend',
    carbs: 32,
    sugar: 20,
    calories: 200,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Beets', 'Strawberries', 'Blueberries', 'Orange Juice', 'Ginger'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_075',
    name: 'Cucumber Mint Refresher',
    description: 'Light and cooling hydrating smoothie',
    carbs: 18,
    sugar: 10,
    calories: 120,
    protein: 4,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Cucumber', 'Mint', 'Lime', 'Coconut Water', 'Spinach'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_076',
    name: 'Coffee Protein Smoothie',
    description: 'Morning energizer with caffeine',
    carbs: 26,
    sugar: 14,
    calories: 280,
    protein: 22,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Cold Brew Coffee', 'Protein Powder', 'Banana', 'Almond Milk', 'Dates'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_077',
    name: 'Apple Cinnamon Oat Smoothie',
    description: 'Warm spiced breakfast smoothie',
    carbs: 42,
    sugar: 22,
    calories: 290,
    protein: 10,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Apple', 'Oats', 'Cinnamon', 'Almond Milk', 'Walnuts'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_078',
    name: 'Papaya Lime Smoothie',
    description: 'Digestive enzyme-rich tropical treat',
    carbs: 30,
    sugar: 22,
    calories: 190,
    protein: 4,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Papaya', 'Lime', 'Coconut Water', 'Mint', 'Ginger'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_079',
    name: 'Blackberry Basil Smoothie',
    description: 'Sophisticated herbal fruit blend',
    carbs: 28,
    sugar: 16,
    calories: 180,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Blackberries', 'Basil', 'Banana', 'Almond Milk', 'Honey'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_080',
    name: 'Pumpkin Spice Smoothie',
    description: 'Fall-inspired cozy smoothie',
    carbs: 34,
    sugar: 18,
    calories: 260,
    protein: 10,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Pumpkin Puree', 'Banana', 'Pumpkin Spice', 'Greek Yogurt', 'Maple Syrup'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_081',
    name: 'Dragon Fruit Pitaya Smoothie',
    description: 'Exotic pink superfruit smoothie',
    carbs: 32,
    sugar: 20,
    calories: 210,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Dragon Fruit', 'Banana', 'Mango', 'Coconut Water', 'Lime'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_082',
    name: 'Spinach Pear Ginger Smoothie',
    description: 'Sweet pear with spicy ginger kick',
    carbs: 28,
    sugar: 18,
    calories: 170,
    protein: 5,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Spinach', 'Pear', 'Ginger', 'Lemon', 'Coconut Water'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_083',
    name: 'Vanilla Cashew Smoothie',
    description: 'Rich and creamy nut-based smoothie',
    carbs: 30,
    sugar: 16,
    calories: 300,
    protein: 12,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Cashews', 'Banana', 'Vanilla Extract', 'Dates', 'Almond Milk'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_084',
    name: 'Watermelon Mint Cooler',
    description: 'Ultra-hydrating summer smoothie',
    carbs: 24,
    sugar: 18,
    calories: 140,
    protein: 3,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Watermelon', 'Mint', 'Lime', 'Cucumber', 'Ice'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_085',
    name: 'Kiwi Spinach Green Smoothie',
    description: 'Vitamin C-rich green smoothie',
    carbs: 28,
    sugar: 16,
    calories: 180,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Kiwi', 'Spinach', 'Banana', 'Apple Juice', 'Chia Seeds'],
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_086',
    name: 'Acai Blueberry Antioxidant Smoothie',
    description: 'Double antioxidant power smoothie',
    carbs: 36,
    sugar: 22,
    calories: 250,
    protein: 8,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Acai Puree', 'Blueberries', 'Banana', 'Almond Milk', 'Hemp Seeds'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_087',
    name: 'Coconut Chia Seed Smoothie',
    description: 'Omega-3 rich tropical smoothie',
    carbs: 32,
    sugar: 18,
    calories: 270,
    protein: 8,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Coconut Milk', 'Chia Seeds', 'Banana', 'Mango', 'Vanilla'],
    image: 'https://images.unsplash.com/photo-1623065422902-30a2d299bbe4?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_088',
    name: 'Almond Joy Smoothie',
    description: 'Chocolate coconut almond delight',
    carbs: 34,
    sugar: 20,
    calories: 320,
    protein: 14,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Almonds', 'Coconut', 'Cocoa Powder', 'Banana', 'Almond Milk'],
    image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_089',
    name: 'Pomegranate Berry Blast',
    description: 'Super antioxidant berry smoothie',
    carbs: 34,
    sugar: 24,
    calories: 210,
    protein: 6,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Pomegranate Juice', 'Mixed Berries', 'Banana', 'Greek Yogurt', 'Honey'],
    image: 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_090',
    name: 'Golden Milk Turmeric Smoothie',
    description: 'Anti-inflammatory golden elixir',
    carbs: 26,
    sugar: 14,
    calories: 230,
    protein: 8,
    prep_time: '5 mins',
    difficulty: 'Easy',
    ingredients: ['Turmeric', 'Ginger', 'Coconut Milk', 'Banana', 'Black Pepper', 'Honey'],
    image: 'https://images.unsplash.com/photo-1638176066666-ffb2f013c7dd?w=400',
    meal_type: 'Smoothie'
  },
  {
    recipe_id: 'recipe_091',
    name: 'Grilled Sirloin Steak with Roasted Vegetables',
    description: 'Lean beef with colorful roasted veggies',
    carbs: 22,
    sugar: 8,
    calories: 420,
    protein: 45,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Sirloin Steak', 'Bell Peppers', 'Zucchini', 'Red Onion', 'Garlic'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_092',
    name: 'Lemon Garlic Shrimp Pasta',
    description: 'Light pasta with succulent shrimp',
    carbs: 42,
    sugar: 4,
    calories: 380,
    protein: 32,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Shrimp', 'Whole Wheat Pasta', 'Garlic', 'Lemon', 'Parsley'],
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_093',
    name: 'Stuffed Bell Peppers',
    description: 'Colorful peppers filled with ground turkey',
    carbs: 28,
    sugar: 10,
    calories: 340,
    protein: 30,
    prep_time: '45 mins',
    difficulty: 'Medium',
    ingredients: ['Bell Peppers', 'Ground Turkey', 'Brown Rice', 'Tomatoes', 'Cheese'],
    image: 'https://images.unsplash.com/photo-1619096252214-ef06c45683e3?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_094',
    name: 'Coconut Curry Chicken',
    description: 'Thai-inspired creamy curry',
    carbs: 32,
    sugar: 8,
    calories: 410,
    protein: 38,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Coconut Milk', 'Curry Paste', 'Vegetables', 'Jasmine Rice'],
    image: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_095',
    name: 'Mediterranean Baked Fish',
    description: 'White fish with tomatoes and olives',
    carbs: 18,
    sugar: 6,
    calories: 320,
    protein: 38,
    prep_time: '30 mins',
    difficulty: 'Easy',
    ingredients: ['White Fish', 'Tomatoes', 'Olives', 'Capers', 'Oregano'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_096',
    name: 'Chicken Fajita Bowl',
    description: 'Tex-Mex inspired protein bowl',
    carbs: 38,
    sugar: 6,
    calories: 420,
    protein: 40,
    prep_time: '30 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Bell Peppers', 'Onions', 'Brown Rice', 'Avocado'],
    image: 'https://images.unsplash.com/photo-1624300629298-e9de39c13be5?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_097',
    name: 'Eggplant Parmesan',
    description: 'Italian vegetarian classic',
    carbs: 36,
    sugar: 12,
    calories: 380,
    protein: 18,
    prep_time: '50 mins',
    difficulty: 'Medium',
    ingredients: ['Eggplant', 'Marinara Sauce', 'Mozzarella', 'Parmesan', 'Basil'],
    image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_098',
    name: 'Teriyaki Salmon Bowl',
    description: 'Asian-glazed salmon with rice',
    carbs: 44,
    sugar: 12,
    calories: 450,
    protein: 36,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Salmon', 'Teriyaki Sauce', 'Brown Rice', 'Broccoli', 'Sesame Seeds'],
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_099',
    name: 'Pork Chops with Apple Compote',
    description: 'Juicy pork with sweet apple sauce',
    carbs: 28,
    sugar: 16,
    calories: 390,
    protein: 38,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Pork Chops', 'Apples', 'Onions', 'Thyme', 'Brussels Sprouts'],
    image: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_100',
    name: 'Vegetarian Chili',
    description: 'Hearty bean and vegetable chili',
    carbs: 42,
    sugar: 10,
    calories: 320,
    protein: 18,
    prep_time: '45 mins',
    difficulty: 'Easy',
    ingredients: ['Kidney Beans', 'Black Beans', 'Tomatoes', 'Peppers', 'Chili Spices'],
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_101',
    name: 'Lemon Herb Roasted Chicken',
    description: 'Whole roasted chicken with herbs',
    carbs: 8,
    sugar: 2,
    calories: 380,
    protein: 44,
    prep_time: '90 mins',
    difficulty: 'Medium',
    ingredients: ['Whole Chicken', 'Lemon', 'Rosemary', 'Garlic', 'Root Vegetables'],
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_102',
    name: 'Shrimp Tacos with Cabbage Slaw',
    description: 'Light and fresh seafood tacos',
    carbs: 36,
    sugar: 6,
    calories: 340,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Shrimp', 'Corn Tortillas', 'Cabbage', 'Lime', 'Cilantro'],
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_103',
    name: 'Mushroom Risotto',
    description: 'Creamy Italian rice dish',
    carbs: 48,
    sugar: 4,
    calories: 380,
    protein: 12,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Arborio Rice', 'Mushrooms', 'Parmesan', 'White Wine', 'Butter'],
    image: 'https://images.unsplash.com/photo-1476124369491-F3a5a95864ae?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_104',
    name: 'BBQ Chicken Pizza',
    description: 'Whole wheat pizza with BBQ chicken',
    carbs: 52,
    sugar: 14,
    calories: 450,
    protein: 32,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Whole Wheat Dough', 'Chicken', 'BBQ Sauce', 'Red Onion', 'Mozzarella'],
    image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_105',
    name: 'Spaghetti Squash Bolognese',
    description: 'Low-carb pasta alternative with meat sauce',
    carbs: 24,
    sugar: 10,
    calories: 320,
    protein: 28,
    prep_time: '50 mins',
    difficulty: 'Medium',
    ingredients: ['Spaghetti Squash', 'Ground Beef', 'Tomato Sauce', 'Garlic', 'Italian Herbs'],
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_106',
    name: 'Lemon Dill Baked Cod',
    description: 'Flaky white fish with fresh dill',
    carbs: 12,
    sugar: 3,
    calories: 280,
    protein: 36,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Cod', 'Dill', 'Lemon', 'Garlic', 'Green Beans'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_107',
    name: 'Chicken Shawarma Plate',
    description: 'Middle Eastern spiced chicken',
    carbs: 38,
    sugar: 6,
    calories: 420,
    protein: 42,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Shawarma Spices', 'Pita', 'Hummus', 'Cucumber Salad'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_108',
    name: 'Beef Stir-Fry with Snow Peas',
    description: 'Quick Asian-style beef dish',
    carbs: 28,
    sugar: 8,
    calories: 380,
    protein: 36,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Beef Strips', 'Snow Peas', 'Ginger', 'Soy Sauce', 'Brown Rice'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_109',
    name: 'Baked Chicken Thighs with Root Vegetables',
    description: 'One-pan roasted dinner',
    carbs: 32,
    sugar: 10,
    calories: 420,
    protein: 38,
    prep_time: '55 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken Thighs', 'Carrots', 'Potatoes', 'Onions', 'Herbs'],
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_110',
    name: 'Turkey Lettuce Wraps with Peanut Sauce',
    description: 'Asian-inspired lettuce cups',
    carbs: 18,
    sugar: 8,
    calories: 300,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Ground Turkey', 'Lettuce', 'Peanut Sauce', 'Water Chestnuts', 'Green Onions'],
    image: 'https://images.unsplash.com/photo-1559847844-5315695dadae?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_111',
    name: 'Blackened Mahi Mahi',
    description: 'Spicy crusted fish fillet',
    carbs: 14,
    sugar: 4,
    calories: 310,
    protein: 38,
    prep_time: '20 mins',
    difficulty: 'Medium',
    ingredients: ['Mahi Mahi', 'Blackening Spices', 'Quinoa', 'Steamed Broccoli', 'Lemon'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_112',
    name: 'Chicken Enchiladas',
    description: 'Mexican rolled tortillas with chicken',
    carbs: 42,
    sugar: 8,
    calories: 440,
    protein: 34,
    prep_time: '45 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Tortillas', 'Enchilada Sauce', 'Cheese', 'Black Beans'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_113',
    name: 'Moroccan Lamb Tagine',
    description: 'Slow-cooked North African stew',
    carbs: 36,
    sugar: 12,
    calories: 460,
    protein: 40,
    prep_time: '90 mins',
    difficulty: 'Medium',
    ingredients: ['Lamb', 'Apricots', 'Chickpeas', 'Moroccan Spices', 'Couscous'],
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_114',
    name: 'Sesame Ginger Tofu',
    description: 'Crispy tofu with Asian glaze',
    carbs: 32,
    sugar: 10,
    calories: 340,
    protein: 22,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Tofu', 'Sesame Oil', 'Ginger', 'Soy Sauce', 'Bok Choy'],
    image: 'https://images.unsplash.com/photo-1607532941433-304659e8198a?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_115',
    name: 'Seared Scallops with Cauliflower Puree',
    description: 'Elegant seafood dinner',
    carbs: 18,
    sugar: 6,
    calories: 320,
    protein: 28,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Scallops', 'Cauliflower', 'Garlic', 'Butter', 'Chives'],
    image: 'https://images.unsplash.com/photo-1580959375944-b6c215f8f700?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_116',
    name: 'Chicken Tikka Masala',
    description: 'Indian curry with tender chicken',
    carbs: 38,
    sugar: 10,
    calories: 450,
    protein: 40,
    prep_time: '50 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Tikka Spices', 'Tomato Cream Sauce', 'Basmati Rice', 'Cilantro'],
    image: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_117',
    name: 'Grilled Portobello Mushroom Burger',
    description: 'Vegetarian burger alternative',
    carbs: 38,
    sugar: 8,
    calories: 320,
    protein: 14,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Portobello Mushrooms', 'Whole Wheat Bun', 'Avocado', 'Tomato', 'Lettuce'],
    image: 'https://images.unsplash.com/photo-1550547660-d9450f859349?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_118',
    name: 'Honey Mustard Glazed Pork Tenderloin',
    description: 'Sweet and tangy pork roast',
    carbs: 22,
    sugar: 12,
    calories: 380,
    protein: 42,
    prep_time: '40 mins',
    difficulty: 'Medium',
    ingredients: ['Pork Tenderloin', 'Honey', 'Mustard', 'Sweet Potatoes', 'Green Beans'],
    image: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_119',
    name: 'Cajun Shrimp and Grits',
    description: 'Southern comfort food favorite',
    carbs: 44,
    sugar: 4,
    calories: 420,
    protein: 32,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Shrimp', 'Grits', 'Cajun Spices', 'Bell Peppers', 'Green Onions'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_120',
    name: 'Herb-Crusted Rack of Lamb',
    description: 'Elegant dinner with herb coating',
    carbs: 16,
    sugar: 4,
    calories: 440,
    protein: 38,
    prep_time: '45 mins',
    difficulty: 'Medium',
    ingredients: ['Rack of Lamb', 'Fresh Herbs', 'Breadcrumbs', 'Garlic', 'Roasted Vegetables'],
    image: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=400',
    meal_type: 'Dinner'
  },
  {
    recipe_id: 'recipe_121',
    name: 'Grilled Chicken Avocado Wrap',
    description: 'Fresh wrap with grilled chicken',
    carbs: 38,
    sugar: 4,
    calories: 420,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Avocado', 'Whole Wheat Tortilla', 'Lettuce', 'Tomato'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_122',
    name: 'Tuna Nicoise Bowl',
    description: 'Classic French salad in bowl form',
    carbs: 28,
    sugar: 6,
    calories: 380,
    protein: 32,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Tuna', 'Eggs', 'Green Beans', 'Potatoes', 'Olives'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_123',
    name: 'Caprese Sandwich',
    description: 'Italian-style fresh mozzarella sandwich',
    carbs: 42,
    sugar: 6,
    calories: 390,
    protein: 18,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Ciabatta Bread', 'Mozzarella', 'Tomatoes', 'Basil', 'Balsamic'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_124',
    name: 'Southwest Chicken Salad',
    description: 'Tex-Mex inspired salad bowl',
    carbs: 32,
    sugar: 6,
    calories: 380,
    protein: 34,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Black Beans', 'Corn', 'Avocado', 'Lime Dressing'],
    image: 'https://images.unsplash.com/photo-1551248429-40975aa4de74?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_125',
    name: 'Vietnamese Banh Mi',
    description: 'Vietnamese sandwich with pickled vegetables',
    carbs: 44,
    sugar: 8,
    calories: 410,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Baguette', 'Pork', 'Pickled Vegetables', 'Cilantro', 'Sriracha Mayo'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_126',
    name: 'Greek Chicken Pita',
    description: 'Mediterranean chicken in pita pocket',
    carbs: 38,
    sugar: 6,
    calories: 400,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Pita Bread', 'Tzatziki', 'Cucumber', 'Red Onion'],
    image: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_127',
    name: 'Cobb Salad',
    description: 'Classic American chopped salad',
    carbs: 18,
    sugar: 6,
    calories: 420,
    protein: 36,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Bacon', 'Eggs', 'Avocado', 'Blue Cheese'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_128',
    name: 'Turkey Club Sandwich',
    description: 'Triple-decker classic sandwich',
    carbs: 48,
    sugar: 6,
    calories: 450,
    protein: 32,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Turkey', 'Bacon', 'Whole Wheat Bread', 'Lettuce', 'Tomato'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_129',
    name: 'Chicken Burrito Bowl',
    description: 'Deconstructed burrito in a bowl',
    carbs: 42,
    sugar: 4,
    calories: 440,
    protein: 38,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Brown Rice', 'Black Beans', 'Salsa', 'Guacamole'],
    image: 'https://images.unsplash.com/photo-1624300629298-e9de39c13be5?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_130',
    name: 'Shrimp Po Boy',
    description: 'Louisiana-style shrimp sandwich',
    carbs: 46,
    sugar: 6,
    calories: 420,
    protein: 28,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Shrimp', 'French Bread', 'Lettuce', 'Tomato', 'Remoulade Sauce'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_131',
    name: 'Asian Chicken Lettuce Cups',
    description: 'Light and refreshing lettuce wraps',
    carbs: 16,
    sugar: 8,
    calories: 280,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Ground Chicken', 'Lettuce', 'Water Chestnuts', 'Hoisin Sauce', 'Green Onions'],
    image: 'https://images.unsplash.com/photo-1559847844-5315695dadae?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_132',
    name: 'Mediterranean Quinoa Bowl',
    description: 'Grain bowl with Mediterranean flavors',
    carbs: 44,
    sugar: 6,
    calories: 390,
    protein: 16,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Quinoa', 'Chickpeas', 'Cucumber', 'Feta', 'Olives'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_133',
    name: 'BLT Avocado Wrap',
    description: 'Classic BLT with avocado twist',
    carbs: 36,
    sugar: 4,
    calories: 410,
    protein: 20,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Bacon', 'Lettuce', 'Tomato', 'Avocado', 'Whole Wheat Tortilla'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_134',
    name: 'Chicken Pesto Panini',
    description: 'Grilled Italian sandwich',
    carbs: 40,
    sugar: 4,
    calories: 430,
    protein: 34,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Pesto', 'Mozzarella', 'Tomatoes', 'Ciabatta'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_135',
    name: 'Taco Salad Bowl',
    description: 'Tex-Mex salad with crispy shell',
    carbs: 38,
    sugar: 6,
    calories: 420,
    protein: 30,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Ground Beef', 'Lettuce', 'Cheese', 'Salsa', 'Tortilla Chips'],
    image: 'https://images.unsplash.com/photo-1551248429-40975aa4de74?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_136',
    name: 'Veggie Hummus Wrap',
    description: 'Plant-based protein wrap',
    carbs: 42,
    sugar: 8,
    calories: 340,
    protein: 14,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Hummus', 'Vegetables', 'Whole Wheat Tortilla', 'Spinach', 'Feta'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_137',
    name: 'Salmon Sushi Bowl',
    description: 'Deconstructed sushi in bowl form',
    carbs: 46,
    sugar: 8,
    calories: 420,
    protein: 32,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Salmon', 'Sushi Rice', 'Avocado', 'Cucumber', 'Seaweed'],
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_138',
    name: 'Italian Sub Sandwich',
    description: 'Deli-style Italian cold cuts sandwich',
    carbs: 44,
    sugar: 6,
    calories: 450,
    protein: 28,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Italian Meats', 'Provolone', 'Lettuce', 'Tomato', 'Sub Roll'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_139',
    name: 'Thai Peanut Noodle Salad',
    description: 'Cold noodle salad with peanut dressing',
    carbs: 48,
    sugar: 10,
    calories: 400,
    protein: 18,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Rice Noodles', 'Peanut Sauce', 'Vegetables', 'Cilantro', 'Peanuts'],
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_140',
    name: 'Chicken Quesadilla',
    description: 'Cheesy grilled tortilla with chicken',
    carbs: 42,
    sugar: 4,
    calories: 460,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Cheese', 'Tortillas', 'Bell Peppers', 'Sour Cream'],
    image: 'https://images.unsplash.com/photo-1618040996337-56904b7850b9?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_141',
    name: 'Spinach Artichoke Stuffed Chicken',
    description: 'Chicken breast with creamy filling',
    carbs: 18,
    sugar: 4,
    calories: 380,
    protein: 42,
    prep_time: '35 mins',
    difficulty: 'Medium',
    ingredients: ['Chicken', 'Spinach', 'Artichokes', 'Cream Cheese', 'Parmesan'],
    image: 'https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_142',
    name: 'Falafel Pita Pocket',
    description: 'Middle Eastern chickpea fritters',
    carbs: 46,
    sugar: 6,
    calories: 380,
    protein: 16,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Falafel', 'Pita Bread', 'Tahini', 'Lettuce', 'Tomatoes'],
    image: 'https://images.unsplash.com/photo-1529042410759-befb1204b468?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_143',
    name: 'Steak Salad with Blue Cheese',
    description: 'Hearty salad with grilled steak',
    carbs: 22,
    sugar: 8,
    calories: 440,
    protein: 38,
    prep_time: '25 mins',
    difficulty: 'Medium',
    ingredients: ['Steak', 'Mixed Greens', 'Blue Cheese', 'Tomatoes', 'Balsamic'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_144',
    name: 'Chicken Noodle Soup',
    description: 'Comforting classic soup',
    carbs: 32,
    sugar: 4,
    calories: 280,
    protein: 24,
    prep_time: '35 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Egg Noodles', 'Carrots', 'Celery', 'Chicken Broth'],
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_145',
    name: 'BBQ Pulled Pork Sandwich',
    description: 'Slow-cooked pork with BBQ sauce',
    carbs: 48,
    sugar: 16,
    calories: 480,
    protein: 34,
    prep_time: '15 mins',
    difficulty: 'Easy',
    ingredients: ['Pulled Pork', 'BBQ Sauce', 'Coleslaw', 'Bun', 'Pickles'],
    image: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_146',
    name: 'Shrimp and Avocado Salad',
    description: 'Light seafood salad',
    carbs: 18,
    sugar: 6,
    calories: 320,
    protein: 28,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Shrimp', 'Avocado', 'Mixed Greens', 'Lime', 'Cilantro'],
    image: 'https://images.unsplash.com/photo-1551248429-40975aa4de74?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_147',
    name: 'Teriyaki Chicken Rice Bowl',
    description: 'Asian-style rice bowl',
    carbs: 52,
    sugar: 14,
    calories: 460,
    protein: 36,
    prep_time: '25 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Teriyaki Sauce', 'Rice', 'Vegetables', 'Sesame Seeds'],
    image: 'https://images.unsplash.com/photo-1624300629298-e9de39c13be5?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_148',
    name: 'Tomato Basil Soup with Grilled Cheese',
    description: 'Classic comfort food combo',
    carbs: 48,
    sugar: 12,
    calories: 420,
    protein: 16,
    prep_time: '30 mins',
    difficulty: 'Easy',
    ingredients: ['Tomatoes', 'Basil', 'Cream', 'Bread', 'Cheese'],
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_149',
    name: 'Buffalo Chicken Wrap',
    description: 'Spicy chicken wrap with ranch',
    carbs: 40,
    sugar: 4,
    calories: 440,
    protein: 32,
    prep_time: '20 mins',
    difficulty: 'Easy',
    ingredients: ['Chicken', 'Buffalo Sauce', 'Ranch', 'Lettuce', 'Tortilla'],
    image: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?w=400',
    meal_type: 'Lunch'
  },
  {
    recipe_id: 'recipe_150',
    name: 'Korean Bibimbap Bowl',
    description: 'Mixed rice bowl with vegetables',
    carbs: 48,
    sugar: 8,
    calories: 420,
    protein: 24,
    prep_time: '30 mins',
    difficulty: 'Medium',
    ingredients: ['Rice', 'Beef', 'Vegetables', 'Egg', 'Gochujang Sauce'],
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=400',
    meal_type: 'Lunch'
  }
];

export const mockMealPlans = [
  {
    plan_id: 'plan_001',
    name: 'Low-Carb Week',
    description: 'A balanced 7-day plan focusing on low carbohydrate meals',
    duration: '7 days',
    total_recipes: 21,
    avg_carbs_per_day: 120
  },
  {
    plan_id: 'plan_002',
    name: 'Heart-Healthy Mediterranean',
    description: 'Mediterranean-inspired meals for cardiovascular health',
    duration: '7 days',
    total_recipes: 21,
    avg_carbs_per_day: 150
  },
  {
    plan_id: 'plan_003',
    name: 'Plant-Based Power',
    description: 'Vegetarian meals rich in nutrients and fiber',
    duration: '5 days',
    total_recipes: 15,
    avg_carbs_per_day: 140
  }
];

export const subscriptionPlans = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    interval: 'forever',
    description: 'Perfect for getting started',
    features: [
      'Basic glucose tracking',
      'Manual meal logging',
      'Up to 50 recipe access',
      'Basic insights',
      'Community support'
    ],
    limitations: [
      'No AI-powered insights',
      'No medication reminders',
      'Limited recipe access',
      'No export reports'
    ],
    color: 'from-gray-500 to-slate-600',
    popular: false
  },
  {
    id: 'basic',
    name: 'Basic',
    price: 9.99,
    interval: 'month',
    description: 'Essential features for daily management',
    features: [
      'Unlimited glucose tracking',
      'Unlimited meal logging',
      'Access to all 150 recipes',
      'Medication reminders',
      'Weekly AI insights',
      'Data export (PDF)',
      'Email support'
    ],
    limitations: [
      'Limited to 10 AI insights/month',
      'No advanced analytics',
      'No priority support'
    ],
    color: 'from-blue-500 to-cyan-600',
    popular: false
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 19.99,
    interval: 'month',
    description: 'Complete diabetes management solution',
    features: [
      'Everything in Basic',
      'Unlimited AI insights',
      'Advanced analytics & trends',
      'Personalized meal plans',
      'Recipe recommendations',
      'Priority support',
      'Multiple device sync',
      'Family account sharing (up to 3)',
      'Custom reports',
      'Integration with wearables'
    ],
    limitations: [],
    color: 'from-emerald-500 to-teal-600',
    popular: true
  },
  {
    id: 'professional',
    name: 'Professional',
    price: 49.99,
    interval: 'month',
    description: 'For healthcare professionals',
    features: [
      'Everything in Premium',
      'Manage up to 50 patients',
      'Healthcare provider dashboard',
      'HIPAA compliance tools',
      'Advanced reporting suite',
      'Direct messaging with patients',
      'Custom branding',
      'API access',
      'Dedicated account manager',
      'White-label options'
    ],
    limitations: [],
    color: 'from-purple-500 to-indigo-600',
    popular: false
  }
];

export const mockUserSubscription = {
  user_id: 'user_001',
  plan_id: 'basic',
  status: 'active',
  start_date: new Date('2024-12-01'),
  next_billing_date: new Date('2025-02-01'),
  cancel_at_period_end: false,
  payment_method: {
    type: 'card',
    last4: '4242',
    brand: 'Visa'
  }
};

export const mockExerciseLogs = [
  {
    log_id: 'ex_001',
    user_id: 'user_001',
    exercise_type: 'Walking',
    duration: 30,
    intensity: 'Moderate',
    calories_burned: 150,
    time: new Date('2025-01-15T07:00:00'),
    notes: 'Morning walk in the park'
  },
  {
    log_id: 'ex_002',
    user_id: 'user_001',
    exercise_type: 'Cycling',
    duration: 45,
    intensity: 'Moderate',
    calories_burned: 320,
    time: new Date('2025-01-15T17:30:00'),
    notes: 'Bike ride to work'
  },
  {
    log_id: 'ex_003',
    user_id: 'user_001',
    exercise_type: 'Swimming',
    duration: 40,
    intensity: 'Vigorous',
    calories_burned: 380,
    time: new Date('2025-01-14T18:00:00'),
    notes: 'Pool session'
  },
  {
    log_id: 'ex_004',
    user_id: 'user_001',
    exercise_type: 'Yoga',
    duration: 60,
    intensity: 'Light',
    calories_burned: 180,
    time: new Date('2025-01-14T08:00:00'),
    notes: 'Morning yoga routine'
  },
  {
    log_id: 'ex_005',
    user_id: 'user_001',
    exercise_type: 'Running',
    duration: 25,
    intensity: 'Vigorous',
    calories_burned: 280,
    time: new Date('2025-01-13T06:30:00'),
    notes: '5K run'
  },
  {
    log_id: 'ex_006',
    user_id: 'user_001',
    exercise_type: 'Weight Training',
    duration: 50,
    intensity: 'Moderate',
    calories_burned: 250,
    time: new Date('2025-01-13T19:00:00'),
    notes: 'Upper body workout'
  },
  {
    log_id: 'ex_007',
    user_id: 'user_001',
    exercise_type: 'Walking',
    duration: 20,
    intensity: 'Light',
    calories_burned: 90,
    time: new Date('2025-01-12T12:00:00'),
    notes: 'Lunch break walk'
  }
];

// Health Tracking Data
export const mockHealthLogs = [
  {
    log_id: 'health_001',
    user_id: 'user_001',
    weight: 75.5,
    blood_pressure_systolic: 120,
    blood_pressure_diastolic: 80,
    date: new Date('2025-01-15'),
    notes: 'Feeling good'
  },
  {
    log_id: 'health_002',
    user_id: 'user_001',
    weight: 75.8,
    blood_pressure_systolic: 118,
    blood_pressure_diastolic: 78,
    date: new Date('2025-01-14'),
    notes: ''
  },
  {
    log_id: 'health_003',
    user_id: 'user_001',
    weight: 76.0,
    blood_pressure_systolic: 122,
    blood_pressure_diastolic: 82,
    date: new Date('2025-01-13'),
    notes: 'Slightly elevated BP'
  },
  {
    log_id: 'health_004',
    user_id: 'user_001',
    weight: 76.2,
    blood_pressure_systolic: 119,
    blood_pressure_diastolic: 79,
    date: new Date('2025-01-12'),
    notes: ''
  }
];

// Daily Journal/Notes
export const mockJournalEntries = [
  {
    entry_id: 'journal_001',
    user_id: 'user_001',
    date: new Date('2025-01-15'),
    mood: 'Good',
    energy_level: 8,
    stress_level: 3,
    notes: 'Had a productive day. Glucose levels were stable. Went for a nice walk.',
    symptoms: []
  },
  {
    entry_id: 'journal_002',
    user_id: 'user_001',
    date: new Date('2025-01-14'),
    mood: 'Great',
    energy_level: 9,
    stress_level: 2,
    notes: 'Feeling energetic! Swimming session was amazing.',
    symptoms: []
  },
  {
    entry_id: 'journal_003',
    user_id: 'user_001',
    date: new Date('2025-01-13'),
    mood: 'Fair',
    energy_level: 6,
    stress_level: 5,
    notes: 'Bit tired today. Glucose spike after lunch.',
    symptoms: ['Fatigue', 'Thirst']
  }
];

// Community Posts
export const mockCommunityPosts = [
  {
    post_id: 'post_001',
    user_name: 'John D.',
    user_avatar: 'JD',
    date: new Date('2025-01-15T10:30:00'),
    content: 'Just hit my 30-day streak of logging! Feeling proud 🎉',
    likes: 24,
    comments: 8,
    category: 'Milestone'
  },
  {
    post_id: 'post_002',
    user_name: 'Emily R.',
    user_avatar: 'ER',
    date: new Date('2025-01-15T09:15:00'),
    content: 'Any tips for managing glucose levels after breakfast? Mine always spike.',
    likes: 12,
    comments: 15,
    category: 'Question'
  },
  {
    post_id: 'post_003',
    user_name: 'Michael S.',
    user_avatar: 'MS',
    date: new Date('2025-01-14T18:45:00'),
    content: 'Found an amazing low-carb recipe! Will share in the recipes section.',
    likes: 18,
    comments: 5,
    category: 'Recipe'
  },
  {
    post_id: 'post_004',
    user_name: 'Lisa M.',
    user_avatar: 'LM',
    date: new Date('2025-01-14T14:20:00'),
    content: 'My A1C dropped from 7.5 to 6.2! Thank you DiaWise community for the support!',
    likes: 45,
    comments: 22,
    category: 'Success'
  }
];

// Family/Care Team Members
export const mockFamilyMembers = [
  {
    member_id: 'fam_001',
    name: 'Dr. Sarah Williams',
    relationship: 'Endocrinologist',
    email: 'dr.williams@healthclinic.com',
    access_level: 'Full',
    avatar: 'SW'
  },
  {
    member_id: 'fam_002',
    name: 'Robert Johnson',
    relationship: 'Spouse',
    email: 'robert.j@email.com',
    access_level: 'View Only',
    avatar: 'RJ'
  },
  {
    member_id: 'fam_003',
    name: 'Nurse Karen',
    relationship: 'Diabetes Educator',
    email: 'karen.nurse@clinic.com',
    access_level: 'Full',
    avatar: 'KN'
  }
];

// AI Predictions
export const mockPredictions = [
  {
    prediction_id: 'pred_001',
    type: 'glucose_forecast',
    predicted_value: 135,
    confidence: 85,
    time_window: '2 hours',
    factors: ['Recent meal (high carbs)', 'Inactive period'],
    recommendation: 'Consider a short walk after this meal'
  },
  {
    prediction_id: 'pred_002',
    type: 'hypoglycemia_risk',
    risk_level: 'Low',
    confidence: 92,
    time_window: 'Next 4 hours',
    factors: ['Recent insulin dose', 'Planned exercise'],
    recommendation: 'Have a small snack before exercise'
  }
];

// Wearable Device Integration
export const mockDeviceData = {
  device_name: 'Apple Watch Series 9',
  last_sync: new Date('2025-01-15T08:00:00'),
  steps_today: 8547,
  heart_rate_avg: 72,
  sleep_hours: 7.5,
  connected: true
};

// Amazon Products for Diabetes
export const amazonProducts = {
  glucoseMonitors: [
    {
      id: 'am_001',
      name: 'Contour Next One Blood Glucose Monitoring System',
      description: 'Smart meter with Bluetooth connectivity and app integration',
      price: 29.99,
      rating: 4.7,
      reviews: 12453,
      image: 'https://images.unsplash.com/photo-1584515933487-779824d29309?w=400',
      category: 'Glucose Monitors',
      amazonUrl: 'https://www.amazon.com/dp/B01N0P8M23',
      features: ['Bluetooth enabled', 'No coding required', 'Second-chance sampling']
    },
    {
      id: 'am_002',
      name: 'OneTouch Verio Reflect Blood Glucose Meter',
      description: 'Meter with color-coded range indicator',
      price: 24.99,
      rating: 4.6,
      reviews: 8932,
      image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400',
      category: 'Glucose Monitors',
      amazonUrl: 'https://www.amazon.com/dp/B07WNQX7KF',
      features: ['Color range indicator', 'Blood sugar mentor', 'Easy to use']
    },
    {
      id: 'am_003',
      name: 'Accu-Chek Guide Blood Glucose Meter Kit',
      description: 'Accurate and easy-to-use glucose meter',
      price: 34.99,
      rating: 4.5,
      reviews: 6721,
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400',
      category: 'Glucose Monitors',
      amazonUrl: 'https://www.amazon.com/dp/B01N0HWQRN',
      features: ['Wide test strip', 'Spill-resistant vial', 'Quick results']
    }
  ],
  testStrips: [
    {
      id: 'am_004',
      name: 'OneTouch Ultra Test Strips (100 Count)',
      description: 'Compatible with OneTouch Ultra meters',
      price: 89.99,
      rating: 4.8,
      reviews: 15234,
      image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=400',
      category: 'Test Strips',
      amazonUrl: 'https://www.amazon.com/dp/B000I5FHM8',
      features: ['100 strips', 'FastDraw technology', 'Long expiration date']
    },
    {
      id: 'am_005',
      name: 'Contour Next Test Strips (100 Count)',
      description: 'Highly accurate test strips',
      price: 94.99,
      rating: 4.7,
      reviews: 11892,
      image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=400',
      category: 'Test Strips',
      amazonUrl: 'https://www.amazon.com/dp/B01N0P8M34',
      features: ['Second-chance sampling', 'No coding', 'Small blood sample']
    }
  ],
  supplies: [
    {
      id: 'am_006',
      name: 'BD Ultra-Fine Insulin Syringes 31G (100 Pack)',
      description: 'Short needle, 0.5cc capacity',
      price: 42.99,
      rating: 4.8,
      reviews: 9821,
      image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400',
      category: 'Insulin Supplies',
      amazonUrl: 'https://www.amazon.com/dp/B000FE8XTS',
      features: ['31 gauge', 'Ultra-fine needle', '100 count']
    },
    {
      id: 'am_007',
      name: 'FRIO Insulin Cooling Case',
      description: 'Keep insulin cool without ice or electricity',
      price: 24.95,
      rating: 4.6,
      reviews: 5432,
      image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400',
      category: 'Insulin Supplies',
      amazonUrl: 'https://www.amazon.com/dp/B000LDUWE8',
      features: ['No ice needed', 'Reusable', 'Travel-friendly']
    },
    {
      id: 'am_008',
      name: 'Medport Insulin Cooler Travel Case',
      description: 'Insulated medication organizer',
      price: 19.99,
      rating: 4.5,
      reviews: 3214,
      image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400',
      category: 'Insulin Supplies',
      amazonUrl: 'https://www.amazon.com/dp/B07GZNQBKJ',
      features: ['Insulated', 'Compact design', 'Multiple pockets']
    }
  ],
  healthyFoods: [
    {
      id: 'am_009',
      name: 'Lakanto Monkfruit Sweetener (1 lb)',
      description: 'Zero calorie, zero glycemic sweetener',
      price: 12.99,
      rating: 4.6,
      reviews: 18234,
      image: 'https://images.unsplash.com/photo-1587735243615-c03f25aaff15?w=400',
      category: 'Healthy Foods',
      amazonUrl: 'https://www.amazon.com/dp/B01KZZGW9K',
      features: ['Zero calories', 'Keto friendly', 'No aftertaste']
    },
    {
      id: 'am_010',
      name: 'Quest Nutrition Protein Bars Variety Pack (12 Count)',
      description: 'Low carb, high protein bars',
      price: 24.99,
      rating: 4.5,
      reviews: 24561,
      image: 'https://images.unsplash.com/photo-1525385133512-2f3bdd039054?w=400',
      category: 'Healthy Foods',
      amazonUrl: 'https://www.amazon.com/dp/B07VWDZRG9',
      features: ['20g protein', 'Low net carbs', 'Gluten-free']
    },
    {
      id: 'am_011',
      name: 'Glucerna Vanilla Nutrition Shake (12 Pack)',
      description: 'Diabetes nutritional shake',
      price: 32.99,
      rating: 4.7,
      reviews: 8923,
      image: 'https://images.unsplash.com/photo-1622484211443-9b8b3303d453?w=400',
      category: 'Healthy Foods',
      amazonUrl: 'https://www.amazon.com/dp/B000G2N4LG',
      features: ['Slow carbs', 'Vitamins & minerals', 'Vanilla flavor']
    }
  ],
  books: [
    {
      id: 'am_012',
      name: 'The Complete Guide to Carb Counting',
      description: 'Essential guide for diabetes management',
      price: 16.99,
      rating: 4.8,
      reviews: 2145,
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400',
      category: 'Books & Resources',
      amazonUrl: 'https://www.amazon.com/dp/1580405304',
      features: ['Updated edition', 'Expert advice', 'Meal planning']
    },
    {
      id: 'am_013',
      name: 'Diabetes Meal Planning and Nutrition For Dummies',
      description: 'Easy-to-understand diabetes nutrition guide',
      price: 19.99,
      rating: 4.6,
      reviews: 1823,
      image: 'https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400',
      category: 'Books & Resources',
      amazonUrl: 'https://www.amazon.com/dp/1119315646',
      features: ['Beginner friendly', 'Recipes included', 'Meal plans']
    }
  ]
};
